export class Utils {

    public static debounce(func: Function, delay: number): (...args: any[]) => void {
        let timeout: ReturnType<typeof setTimeout>;

        return (...args): void => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), delay);
        };
    }

    public static Sleep(time: number): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            setTimeout(() => {
                resolve();
            }, time);
        });
    }

    public static getHyphenatedString(str?: string): string {
        if (!str) return "";
        // Replace all non-alphanumeric characters and spaces with hyphens
        let modifiedString = str.replace(/[^a-zA-Z0-9]+/g, '-');

        // Remove any leading or trailing hyphens
        modifiedString = modifiedString.replace(/^[-]+|[-]+$/g, '');

        return modifiedString.toLowerCase();
    }

    public static generateRandomString(length: number = 10) {
        const characters = 'abcdefghijklmnopqrstuvwxyz';
        let result = '';
        for (let i = 0; i < length; i++) {
            const randomIndex = Math.floor(Math.random() * characters.length);
            result += characters[randomIndex];
        }
        return result;
    }
    public static formatCurrency = (amount: number, currency: string = "INR") => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency
        }).format(amount);
    };
    public static formatDate = (date: number | Date | undefined) => {
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    };


    public static getDistinctValues(obj: Record<string, string>): string[] {
        const uniqueValues = new Set(Object.values(obj));
        return Array.from(uniqueValues);
    }
    public static isEmail(input: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(input);
    }
    public static isPhoneNumber(input: string): boolean {
        const phoneRegex = /^\+?[1-9]\d{9,14}$/; // Supports international numbers
        return phoneRegex.test(input);
    }

    public static validateUsernameInput(input: string): "email" | "phone" | "invalid" {
        if (this.isEmail(input)) return "email";
        if (this.isPhoneNumber(input)) return "phone";
        return "invalid";
    }

}